import { FC } from 'react';
import { useQuery } from '@tanstack/react-query';
import queryString from 'query-string';
import { UserCycle } from '../../../common/model/dto/user-cycle/user-cycle';
import { getUserCycles } from '../../../services/admin/admin-user-cycles.service';
import CycleSelector from './CycleSelector';

interface AdminCycleSelectorProps {
  userId?: string;
  selectedCycleId: string;
  onCycleSelect: (cycle: UserCycle) => void;
  enabled: boolean;
}

const AdminCycleSelector: FC<AdminCycleSelectorProps> = ({
  userId,
  selectedCycleId,
  onCycleSelect,
  enabled,
}) => {
  const { data, isPending } = useQuery({
    queryKey: ['admin-admin-user-cycles', userId],
    queryFn: () =>
      getUserCycles(
        userId!,
        queryString.stringify({
          limit: 100,
          offset: 0,
          order_by: 'start_day',
          order_dir: 'desc',
        })
      ),
    retry: 3,
    enabled: !!userId && enabled,
  });

  return (
    <CycleSelector
      cycles={data?.docs ?? []}
      selectedCycleId={selectedCycleId}
      onCycleSelect={onCycleSelect}
      isLoading={isPending}
    />
  );
};

export default AdminCycleSelector;
